import { GlobalEventModal } from "features/CenterContent/RoleContent/GlobalEvents/GlobalEventModal";
import { InfrastructureEventCreatedResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { FC, useState } from "react";
import {
  ButtonGroup,
  DialogBody,
  DialogFooter,
  DialogRoot,
  DropsButton,
  DropsDialogContent,
  DropsDialogHeader,
  DropsStaticAlert,
  Separator,
  Text,
} from "shared/components/Spor";

type MajorEventWarningProps = {
  response: InfrastructureEventCreatedResponse;
  onClose: () => void;
};

export const MajorEventWarning: FC<MajorEventWarningProps> = ({
  response,
  onClose,
}) => {
  const [showGlobalModal, setShowGlobalModal] = useState(false);
  return showGlobalModal ? (
    <GlobalEventModal onClose={onClose} relatedInfrastructureEvent={response} />
  ) : (
    <DialogRoot open onOpenChange={onClose} size="lg" placement="center">
      <DropsDialogContent>
        <DropsDialogHeader />
        <DialogBody>
          <DropsStaticAlert variant="important" title="OBS!">
            <Text>
              Hendelsen du opprettet ser ut som et stort avvik. Vurder å gi det
              ekstra synlighet ved å opprette en Global driftsmelding i tillegg.
            </Text>
          </DropsStaticAlert>
        </DialogBody>
        <DialogFooter
          justifyContent="space-between"
          width="100%"
          pb="24px"
          flexDir="column"
        >
          <Separator w="calc(100% + 36px)" mb="10px" />
          <ButtonGroup justifyContent="space-between" mt="12px" w="100%">
            <DropsButton type="button" variant="tertiary" onClick={onClose}>
              Ikke nå
            </DropsButton>
            <DropsButton
              type="button"
              variant="primary"
              onClick={() => setShowGlobalModal(true)}
            >
              Opprett global driftsmelding
            </DropsButton>
          </ButtonGroup>
        </DialogFooter>
      </DropsDialogContent>
    </DialogRoot>
  );
};
